import React from 'react';
import LinkItem from './LinkItem';
import FirebaseContext from '../../firebase/context';

function SearchLinks() {
  const { firebase } = React.useContext(FirebaseContext);
  const [filteredLinks, setFilteredLinks] = React.useState([]);
  const [links, setLinks] = React.useState([]); //initial empty array
  const [filter, setFilter] = React.useState('');  //setFilter, string filter setzen und in filter speichern

  //useEffect runs when component mount
  React.useEffect(() => {
    getInitialLinks();
  }, []);  //empty array for dependencies

  function getInitialLinks() {
    firebase.db
      .collection('links')
      .get()
      .then(snapshot => {
        const links = snapshot.docs.map(doc => {
          return { id: doc.id, ...doc.data() };  //spread in data..
        });
        setLinks(links); //pass in links to array from state
      });
  }

  function handleSearch(event) {
    event.preventDefault();
    const query = filter.toLowerCase(); //eingaben von filter
    const matchedLinks = links.filter(link => {
      return (
        link.description.toLowerCase().includes(query) ||
        link.url.toLowerCase().includes(query) ||
        link.postedBy.name.toLowerCase().includes(query)
      );
    });
    setFilteredLinks(matchedLinks);
  }

  //div rounded!
  return (
    <div>
      <form onSubmit={handleSearch}>
        <div>
          Suche <input onChange={event => setFilter(event.target.value)} />
          <button>OK</button>
        </div>
      </form>
      {filteredLinks.map((filteredLink, index) => (
        <LinkItem
          key={filteredLink.id}
          showCount={false}
          link={filteredLink}
          index={index}
        />
      ))}
    </div>
  );
}

export default SearchLinks;
